import {create} from 'zustand';

const useSectionsStore = create((set) => ({

    homeHeroSection: null,


    setSectionRef: (section, ref) => set((state) => ({ ...state, [section]: ref })),
}));

export default useSectionsStore;